export default __webpack_public_path__ + "static/media/Onion.7540ea40.jpg";